/**
 * Duration of each placeholder animation tick (i.e. time it takes to type 1 character)
 */
export const TICK_DURATION = 60;

/**
 * Number of ticks the animation will pause for when completing a placeholder, before jumping to the next
 */
export const TICKS_TO_NEXT_PLACEHOLDER = 30;
